import React, { useEffect, useState } from 'react';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';

const Kit = ({ _id }) => {
  const [kit, setKit] = useState({});

  useEffect(() => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/gere/kit/' + _id, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setKit(data));
  }, [_id]);

  return <div><PhoneAndroidIcon />{kit.Appareils === undefined ? 0 : kit.Appareils.length}</div>;
};

export default Kit;



// WEBPACK FOOTER //
// src/components/kits/Kit.js